import { render, staticRenderFns } from "./task-overdue-msg.vue?vue&type=template&id=37690694&scoped=true&"
import script from "./task-overdue-msg.vue?vue&type=script&lang=js&"
export * from "./task-overdue-msg.vue?vue&type=script&lang=js&"
import style0 from "./task-overdue-msg.vue?vue&type=style&index=0&id=37690694&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37690694",
  null
  
)

export default component.exports